import React from 'react';
import { useTranslation } from 'react-i18next';

export const SR_TYPE_ICONS = {
  call_waiter: '👋',
  request_bill: '💳',
  need_help: '❓',
  water: '💧',
  napkins: '🧻',
  utensils: '🍴',
  other: '🔔',
};

export const SR_PRIORITY_ORDER = { urgent: 0, high: 1, medium: 2, low: 3 };

export function timeAgo(dateStr, t) {
  const diff = Math.max(0, Date.now() - new Date(dateStr).getTime());
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return t('orders.serviceRequests.justNow');
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return t('orders.serviceRequests.timeAgo', { time: `${minutes}m` });
  const hours = Math.floor(minutes / 60);
  return t('orders.serviceRequests.timeAgo', { time: `${hours}h` });
}

export default function ServiceRequestCard({
  request,
  actionId,
  onAcknowledge,
  onComplete,
  onCancel,
}) {
  const { t } = useTranslation();
  const sr = request;
  const isBusy = actionId === sr.id;
  const isOpen = sr.status === 'pending' || sr.status === 'acknowledged';

  return (
    <div className={`sr-card sr-card--${sr.status} sr-card--priority-${sr.priority}`}>
      <div className="sr-card-header">
        <div className="sr-card-icon">{SR_TYPE_ICONS[sr.request_type] || '🔔'}</div>
        <div className="sr-card-meta">
          <span className="sr-card-type">
            {t(`orders.serviceRequests.type.${sr.request_type}`, { defaultValue: sr.request_type })}
          </span>
          <span className="sr-card-table">
            {t('orders.serviceRequests.table', { table: sr.table_number })}
          </span>
        </div>
        <div className="sr-card-right">
          <span className={`sr-priority-badge sr-priority-badge--${sr.priority}`}>
            {t(`orders.serviceRequests.priority.${sr.priority}`)}
          </span>
          <span className="sr-card-time">{timeAgo(sr.created_at, t)}</span>
        </div>
      </div>
      {sr.message && (
        <div className="sr-card-message">
          <span className="sr-message-icon">💬</span>
          <span>{sr.message}</span>
        </div>
      )}
      {sr.acknowledged_by_name && (
        <div className="sr-card-ack">
          {t('orders.serviceRequests.acknowledgedBy', { name: sr.acknowledged_by_name })}
        </div>
      )}
      <div className="sr-card-actions">
        <span className={`sr-status-badge sr-status-badge--${sr.status}`}>
          {t(`orders.serviceRequests.status.${sr.status}`)}
        </span>
        <div className="sr-action-buttons">
          {sr.status === 'pending' && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => onAcknowledge(sr.id)}
              disabled={isBusy}
            >
              {t('orders.serviceRequests.acknowledge')}
            </button>
          )}
          {isOpen && (
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={() => onComplete(sr.id)}
              disabled={isBusy}
            >
              {t('orders.serviceRequests.markComplete')}
            </button>
          )}
          {isOpen && (
            <button
              type="button"
              className="btn btn-secondary btn-sm sr-cancel-btn"
              onClick={() => onCancel(sr.id)}
              disabled={isBusy}
            >
              {t('orders.serviceRequests.cancel')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
